// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";
import InputMask from "react-input-mask";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";

// To use another component instead of regular <input /> pass render function as a children.
// Function receives props argument which contains props that aren't used by react-input-mask's internals.
// I.e. it passes down every prop except the following ones: onChange, onPaste, onMouseDown, onFocus, onBlur,
// value, disabled, readOnly. These properties, if used, should always be passed directly to react-input-mask
// instead of children and shouldn't be altered in children's function.

// https://github.com/sanniassin/react-input-mask/tree/v2#children--function

function MaskedInput({
  mask,
  formatChars,
  onChange,
  onPaste,
  onMouseDown,
  onFocus,
  onBlur,
  value,
  disabled,
  readOnly,
  ...props
}) {
  return (
    <InputMask
      mask={mask}
      formatChars={formatChars}
      onChange={onChange}
      onPaste={onPaste}
      onMouseDown={onMouseDown}
      onFocus={onFocus}
      onBlur={onBlur}
      value={value}
      disabled={disabled}
      readOnly={readOnly}
      {...{ props }}
    >
      {(inputProps) => (
        <TextField InputLabelProps={{ shrink: true }} {...inputProps.props} />
      )}
    </InputMask>
  );
}

MaskedInput.propTypes = {
  mask: PropTypes.string.isRequired,
  value: PropTypes.string,
  helperText: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onPaste: PropTypes.func,
  onMouseDown: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

MaskedInput.defaultProps = {
  type: "text",
  variant: "outlined",
};

export default MaskedInput;
